<template>
  <div class="commerce-settings">
    <div class="modal commerce-settings-modal">
      <div class="modal-background" @click="closeModal" />
      <button class="modal-close is-large" @click="closeModal" />

      <div class="modal-card" :class="{ 'full-width': showMenu }">
        <section class="modal-card-body" :class="{ 'full-width': showMenu }">
          <div v-show="updating" class="updating">
            <i class="fa fa-spinner fa-spin has-text-danger fa-lg" />
          </div>
          <p
            class="has-text-weight-medium has-text-left"
            style="font-size: 1.35em"
          >
            <span v-if="!showMenu">
              {{ $t("commerce.commerce-settings") }}
              <span
                class="button is-rounded is-pulled-right"
                style="padding: 10px"
                @click="showMenu = true"
              >
                <i class="fa fa-arrow-right wiggle" />
              </span>
            </span>
            <span v-else class="has-text-dark">
              <span
                class="button is-rounded"
                style="padding: 10px"
                @click="showMenu = false"
              >
                <i class="fa fa-arrow-left wiggle" />
              </span>
              Digital Menu
              <span
                class="
                  button
                  is-rounded is-success is-pulled-right
                  advanced-btn
                "
                @click="goto('menu_editor')"
                >Advanced</span
              >
            </span>
          </p>
          <label class="label has-text-link has-text-left">
            <span v-if="!showMenu">
              <span @click="editMenu">
                Digital Menu&nbsp;
                <span class="tag is-link">{{ this.items.length }} Items</span>
              </span>
              <i
                class="fa fa-external-link-alt is-pulled-right"
                @click="viewMenu"
              />
            </span>
            <span v-else>
              <span v-if="menuUpdatedAt">
                <span class="tag is-light" @click="showUpdatedAt"
                  >Updated {{ menuUpdatedAt }}</span
                >&nbsp;
                <span
                  class="tag is-dark is-rounded"
                  :style="staffNotesStyle"
                  @click="showStaffNotes = !showStaffNotes"
                >
                  <i class="fa fa-mitten fa-lg" style="font-size: 1.1em" />
                </span>
              </span>
              <span v-else class="tag is-light">New</span>

              <span class="buttons is-pulled-right is-uppercase">
                <span
                  v-for="l in languages"
                  :key="l"
                  class="button is-small is-link is-rounded"
                  :class="{ 'is-outlined': contentLang !== l }"
                  @click="setContentLang(l)"
                  >{{ l }}</span
                >
              </span>
            </span>
          </label>

          <input
            type="file"
            ref="file"
            style="display: none"
            accept="image/png,image/jpeg,image/jpg,image/bmp"
            @change="uploadMenuPic($event)"
            :key="zFile"
          />

          <!-- edit menu -->
          <div v-if="showMenu" style="border-top: 0.5px solid #ddd">
            <div
              ref="scrollable"
              class="no-scrollbar gpu-accelerated"
              style="overflow: scroll; max-height: calc(90vh - 200px)"
            >
              <div v-for="(o, i) in items" :key="i">
                <div class="field has-addons">
                  <div class="control">
                    <a class="button is-light" @click="takePhoto(i)">
                      <span class="icon">
                        <i class="fa fa-camera" :class="hasPicClass(o)" />
                      </span>
                    </a>
                  </div>
                  <div class="control is-expanded">
                    <input
                      class="input is-light"
                      v-model="o.name"
                      placeholder="Item Name"
                    />
                    <span
                      v-if="o.out_of_stock"
                      class="tag is-danger"
                      style="
                        position: absolute;
                        right: 0px;
                        top: 7px;
                        opacity: 0.7;
                        padding: 3px;
                      "
                      @click="errorToast('Out of stock', 'top')"
                      >Out of stock</span
                    >
                  </div>
                  <div class="control has-icons-left">
                    <span
                      class="icon is-small is-left"
                      style="width: 25px; color: grey"
                      >{{ currency }}</span
                    >
                    <input
                      class="input is-light"
                      style="width: 69px; padding-left: 18px; padding-right: 0"
                      v-model="o.price"
                      type="number"
                      placeholder="Price"
                    />
                  </div>
                  <div class="control">
                    <a
                      class="button is-light"
                      style="padding: 4px 4px"
                      @click="deleteMenuItem(i)"
                    >
                      <i class="fa fa-times-circle has-text-black" />
                    </a>
                  </div>
                </div>
                <div class="control notes" style="margin-top: -13px">
                  <p
                    style="background-color: lightyellow"
                    @click="editDescription(o)"
                  >
                    <span>{{
                      o.description || "✏️ Click to set item description"
                    }}</span>
                  </p>
                  <p
                    v-if="showStaffNotes"
                    style="background-color: #fed8b1"
                    @click="editStaffNotes(o)"
                  >
                    <span>{{ o.notes || "✏️ Click to set staff notes" }}</span>
                  </p>
                </div>
                <div style="height: 12px" />
              </div>
              <div class="has-text-centered" style="margin: -5px 0">
                <img
                  src="/img/home2/minus.svg"
                  style="width: 30px; margin-bottom: -15px; padding: 0 0"
                />
              </div>
              <p style="opacity: 0.7; font-weight: 500; margin: 8px 0">
                End of Menu
              </p>
            </div>
            <div style="padding-top: 8px; border-top: 0.5px solid #ddd">
              <span
                class="button is-warning is-rounded"
                style="padding: 10px"
                @click="addItemToMenu"
              >
                <i class="fa fa-plus" />&nbsp;Add Item </span
              >&nbsp;
              <span class="button is-primary is-rounded" @click="saveMenu">
                <i class="fa fa-save" />&nbsp;Save
              </span>
            </div>
          </div>

          <div v-else :key="z">
            <span class="icon tag is-small is-link is-pulled-right">
              <i class="fa fa-info" @click="menuDiscountInfo" />
            </span>
            <label
              class="label has-text-link has-text-left"
              @click="showDiscount = !showDiscount"
            >
              Menu Discount
              <span class="has-text-weight-medium">
                <span v-if="currentDiscount" class="tag is-success">{{
                  currentDiscount
                }}</span>
                <span v-else class="tag is-warning">None</span>
              </span>
            </label>
            <fade-transition>
              <div
                v-show="showDiscount"
                class="discounts has-text-centered single-line no-scrollbar"
                style="overflow: scroll; width: 100%"
              >
                <span :class="discountBtn" @click="preDiscount(0)">
                  <i
                    class="fa fa-times-circle has-text-link"
                    style="padding: 3px"
                  />
                </span>
                <span :class="discountBtn" @click="preDiscount(10)"
                  >10% Off</span
                >
                <span :class="discountBtn" @click="preDiscount(15)"
                  >15% Off</span
                >
                <span :class="discountBtn" @click="preDiscount(20)"
                  >20% Off</span
                >
                <span :class="discountBtn" @click="preDiscount(25)"
                  >25% Off</span
                >
                <span :class="discountBtn" @click="preDiscount(30)"
                  >30% Off</span
                >
                <span :class="discountBtn" @click="preDiscount(35)"
                  >35% Off</span
                >
                <span :class="discountBtn" @click="preDiscount(40)"
                  >40% Off</span
                >
                <span :class="discountBtn" @click="preDiscount(45)"
                  >45% Off</span
                >
                <span :class="discountBtn" @click="preDiscount(50)"
                  >50% Off</span
                >
              </div>
            </fade-transition>

            <div v-if="workflow.data.delivery">
              <span class="icon tag is-small is-link is-pulled-right">
                <i class="fa fa-info" @click="freeDeliveryOverInfo" />
              </span>
              <label
                class="label has-text-link has-text-left"
                @click="showFreeDeliveryOver = !showFreeDeliveryOver"
              >
                Free Delivery Over
                <span class="has-text-weight-medium">
                  <span v-if="currentFreeDeliveryOver" class="tag is-success">{{
                    currentFreeDeliveryOver
                  }}</span>
                  <span v-else class="tag is-warning">None</span>
                </span>
              </label>
              <fade-transition>
                <div
                  v-show="showFreeDeliveryOver"
                  class="discounts has-text-centered single-line no-scrollbar"
                  style="overflow: scroll; width: 100%"
                >
                  <span
                    :class="discountBtn"
                    @click="setFreeDeliveryOver(false)"
                  >
                    <i class="fa fa-times-circle" style="padding: 3px" />
                  </span>
                  <span :class="discountBtn" @click="setFreeDeliveryOver(-1)"
                    >All</span
                  >
                  <span
                    v-for="val in freeDeliveryOverAmounts"
                    :key="val"
                    :class="discountBtn"
                    @click="setFreeDeliveryOver(val)"
                  >
                    {{ currency }}{{ val }}
                  </span>
                  <!-- <span :class="discountBtn" @click="setFreeDeliveryOver(100)"
                    >฿100</span
                  > -->
                </div>
              </fade-transition>
            </div>

            <div v-if="workflow.data.delivery">
              <label class="label has-text-link has-text-left">
                <span @click="showFreeDeliveryTo = !showFreeDeliveryTo"
                  >Free Delivery To</span
                >
                <span
                  class="has-text-weight-medium tags has-addons is-marginless"
                  style="display: inline-block; padding-left: 5px"
                  @click="setFreeDeliveryTo"
                >
                  <span v-if="freeDeliveryTo" class="tag is-success">{{
                    freeDeliveryTo
                  }}</span>
                  <span v-else class="tag is-warning">None</span>
                  <span class="tag is-dark has-text-success">
                    <i class="fa fa-pencil-alt" />
                  </span>
                </span>
                <span style="margin-left: 4px">
                  <span
                    v-if="workflow.data.free_delivery_polygon"
                    class="has-text-link"
                  >
                    <i class="fa fa-check-circle" />&nbsp;&nbsp;
                    <i class="fa fa-external-link-alt" @click="viewPolygon" />
                  </span>
                  <span v-else style="color: orange">
                    <i class="fa fa-cog fa-spin" />
                  </span>
                </span>
                <span class="icon tag is-small is-link is-pulled-right">
                  <i class="fa fa-info" @click="freeDeliveryToInfo" />
                </span>
              </label>
              <!-- <div
                v-if="freeDeliveryTo && !workflow.data.free_delivery_polygon"
                class="has-text-right"
              >
                <i style="color:orange">
                  <i class="fa fa-map" />&nbsp;Contact TUK to complete setup
                </i>
              </div>-->
              <fade-transition>
                <div
                  v-show="showFreeDeliveryTo"
                  class="has-text-left discounts single-line"
                  style="width: 100%"
                >
                  <span :class="discountBtn" @click="clearPolygon">
                    <i class="fa fa-times-circle" style="padding: 3px" />
                  </span>
                  <span :class="discountBtn" @click="setCustom">Custom</span>
                  <span :class="discountBtn" @click="setRadius">Radius</span>
                </div>
              </fade-transition>
            </div>

            <div v-if="isSelfDelivery">
              <label
                class="label has-text-link has-text-left"
                @click="setDeliveryFeePerKM"
              >
                Delivery Fee Per KM
                <span v-if="deliveryFeePerKM" class="tag is-success"
                  >{{ currency }}{{ deliveryFeePerKM }} per km</span
                >
                <span v-else class="tag is-warning">None</span>
              </label>
              <!-- </div> -->

              <label
                class="label has-text-link has-text-left"
                @click="setMinDeliveryFee"
              >
                Min Delivery Fee
                <span v-if="minDeliveryFee" class="tag is-success"
                  >{{ currency }}{{ minDeliveryFee }}</span
                >
                <span v-else class="tag is-warning">None</span>
              </label>

              <!-- <div v-if="workflow.data.express"> -->
              <label
                class="label has-text-link has-text-left"
                @click="setMaxDistance"
              >
                Max Delivery Distance
                <span v-if="maxDistance" class="tag is-success"
                  >{{ maxDistance }} km</span
                >
                <span v-else class="tag is-warning">None</span>
              </label>
            </div>

            <label
              class="label has-text-link has-text-left"
              @click="setMinOrder"
            >
              Minimum Order
              <span v-if="minOrder" class="tag is-success"
                >{{ currency }}{{ minOrder }}</span
              >
              <span v-else class="tag is-warning">None</span>
            </label>
            <hr style="height: 3px; margin: 0px" />
            <div>
              <span class="icon tag is-small is-link is-pulled-right">
                <i class="fa fa-info" @click="shopClosedInfo" />
              </span>
              <label
                class="label has-text-info has-text-left"
                @click="showShopClosed = !showShopClosed"
              >
                <!-- @click="setShopClosed" -->
                Open/Closed
                <span v-if="shopClosed" class="tag is-danger"
                  >Until {{ shopClosed }}</span
                >
                <span v-else class="tag is-info">Normal Hours</span>
              </label>
              <fade-transition>
                <div v-show="showShopClosed" class="has-text-left">
                  <p style="margin-bottom: 4px">
                    <i>Close for how many days?</i>
                  </p>
                  <div class="discounts single-line" style="width: 100%">
                    <span :class="infoBtn" @click="setShopClosed(null)">
                      <i class="fa fa-times-circle" style="padding: 3px" />
                    </span>
                    <span :class="infoBtn" @click="setShopClosed(1)"
                      >1 Day</span
                    >
                    <span :class="infoBtn" @click="setShopClosed(2)"
                      >2 Days</span
                    >
                    <span :class="infoBtn" @click="setShopClosed(3)"
                      >3 Days</span
                    >
                    <span :class="infoBtn" @click="setShopClosed(4)"
                      >4 Days</span
                    >
                    <span :class="infoBtn" @click="setShopClosed(60)"
                      >Manual</span
                    >
                  </div>
                  <div class="link">Re-open (Revert to normal hours)</div>
                </div>
              </fade-transition>
            </div>

            <hr style="height: 3px; margin: 0px" />

            <div class="has-text-grey has-text-left" style="margin-top: 8px">
              <p>
                <i @click="viewInstagramMenu"
                  >Use these tools to get more orders!</i
                >
              </p>
              <p>Need help?</p>
              <a
                href="https://m.me/tukapp"
                target="_blank"
                class="button is-link is-rounded is-small is-outlined"
                style="padding: 0 12px"
              >
                <span class="icon">
                  <i class="fa fa-phone" />
                </span>
                {{ $t("contact-us") }}
                <span class="icon">
                  <i class="fa fa-comments" />
                </span>
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- <fade-transition>
      <CommerceDigitalMenu
        v-if="showMenu"
        :workflow="selected"
        @close="showMenu = null"
      />
    </fade-transition> -->
  </div>
</template>

<script>
import EventBus from "../eventBus";
import imageCompression from "browser-image-compression";

// import CommerceDigitalMenu from "@/components/CommerceDigitalMenu.vue";

const shortid = require("shortid");

export default {
  name: "CommerceSettingsModal",
  components: {
    // CommerceDigitalMenu,
  },
  data() {
    return {
      showDiscount: false,
      showFreeDeliveryOver: false,
      showFreeDeliveryTo: false,
      showShopClosed: false,
      updating: false,
      liveLink: null,
      promoLink: null,
      items: [], // menu items
      showMenu: false,
      menu: null,
      picIndex: 0, // used for photo upload
      contentLang: "en", // default English
      languageBool: false,
      showStaffNotes: false,
      z: 0, // not being used, might not be necessary
      zFile: 100, // attempt to fix Jig bug of uploading same file to different item
    };
  },
  computed: {
    freeDeliveryOverAmounts() {
      if (this.business.country === "sg") {
        return [9, 19, 29, 39, 49, 59, 69, 79, 89, 99]; // sgd intervals
      }
      return [99, 149, 199, 249, 299, 349, 399, 449, 499, 549, 599]; // thai baht intervals
    },
    discountBtn() {
      return "button is-small is-grey is-rounded has-text-link";
    },
    infoBtn() {
      return "button is-small is-grey is-rounded has-text-info";
    },
    role() {
      return this.$store.getters.getCommerceAgentRole;
    },
    workflow() {
      return this.role.workflow;
    },
    languages() {
      return this.workflow.data.languages || ["en", "th"]; // otherwise show default languages...
    },
    business() {
      return this.role.business;
    },
    currency() {
      return this.currencySymbol(this.business.country);
    },
    menuUpdatedAt() {
      if (this.menu) {
        return new Date(this.menu.updated_at)
          .toLocaleDateString("en-GB")
          .substring(0, 5);
      }
      return null;
    },
    languageClass() {
      if (this.languageBool) return "is-success";
      return "is-danger";
    },
    staffNotesStyle() {
      if (this.showStaffNotes) return `background-color:orange`;
      return null;
    },
    currentDiscount() {
      var d = {};
      var none = true; // track if there are none
      this.items.forEach((o) => {
        if (o.discount) {
          none = false;
          if (d[o.discount]) d[o.discount] += 1;
          else d[o.discount] = 1;
        }
      });
      if (none) return null;
      var str = ``;
      for (var [k, v] of Object.entries(d)) {
        str = str + `${k}% (${v}), `;
      }
      return str.slice(0, -2);
    },
    currentFreeDeliveryOver() {
      if (!this.workflow.data.free_delivery_over) return null;
      // if (typeof this.workflow.data.free_delivery === "boolean") return `All orders`;
      // return "฿" + this.workflow.data.free_delivery;
      if (this.workflow.data.free_delivery_over === -1) return `All orders`;
      return this.currency + this.workflow.data.free_delivery_over;
    },
    freeDeliveryTo() {
      if (!this.workflow.data.free_delivery_to) return null;
      return this.workflow.data.free_delivery_to;
    },
    minOrder() {
      return this.workflow.data.min_order;
    },
    maxDistance() {
      return this.workflow.data.max_distance;
    },
    minDeliveryFee() {
      return this.workflow.data.min_delivery_fee;
    },
    deliveryFeePerKM() {
      return this.workflow.data.delivery_fee_per_km;
    },
    isSelfDelivery() {
      if (this.workflow.data.express === "self") return true;
      return false;
    },
    closedUntil() {
      if (!this.workflow.data.closed_until) return null;
      return this.isFutureTime(this.workflow.data.closed_until);
    },
    shopClosed() {
      if (!this.closedUntil) return null;
      return this.shortDateTime(this.workflow.data.closed_until);
      //   return this.workflow.data.shop_closed; // { date: '2020-07-01', n_days: 3}
    },
  },
  mounted() {
    EventBus.$on("OPEN_COMMERCE_SETTINGS", () => {
      console.log("open commerce settings");
      this.getBlobs();
    });
    this.addItemToMenu();
  },
  beforeDestroy() {
    EventBus.$off("OPEN_COMMERCE_SETTINGS");
  },
  methods: {
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    viewInstagramMenu() {
      this.goto(`/shop/${this.role.business_id}?insta=true`);
    },
    shopClosedInfo() {
      var red = this.bulmaColor("danger");
      var blue = this.bulmaColor("info");
      this.$swal({
        title: `<i class='fa fa-clock' style='color:${red}'></i>&nbsp;<i class='fa fa-calendar' style='color:${blue}'></i>`,
        html: `Is your shop closed today?<br><br>Let your customers know when you're not operating normal hours.`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    setShopClosed(days) {
      this.workflow.data.closed_until = null; // default
      if (days) {
        var dt = new Date();
        dt.setDate(dt.getDate() + days);
        this.workflow.data.closed_until = dt.toISOString();
      }
      var loader = this.loadingDots("palegreen");
      this.$store
        .dispatch("updateWorkflow", {
          id: this.workflow.id,
          business_id: this.workflow.business_id,
          data: this.workflow.data,
        })
        .then(() => this.$toast.open("Success"))
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    setDeliveryFeePerKM() {
      this.$swal({
        title: `<div style='color:orange'><i class='fa fa-route'></i>&nbsp;<i class='fa fa-coins'></i></div>`,
        html: `Set delivery fee per KM.<br><br>E.g. at 10 baht per km, 4.5 km = 45 baht delivery fee.`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Delete",
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("primary"),
        input: "number",
        inputValue: this.workflow.data.delivery_fee_per_km,
        inputPlaceholder: this.currency + "10 per km",
        inputValidator: (val) => {
          if (!val) return `Enter a delivery fee per km or delete`;
          if (val > 80) return `Are you sure that's right? Enter per km fee.`;
        },
      }).then((val) => {
        if (val.dismiss === "backdrop" || val.dismiss === "close") return; // don't do anything

        var fee = parseFloat(val.value);
        if (val.dismiss === "cancel") fee = null; // cancel deletes

        this.workflow.data.delivery_fee_per_km = fee;

        var loader = this.loadingDots("teal");
        this.$store
          .dispatch("updateWorkflow", {
            id: this.workflow.id,
            data: this.workflow.data,
          })
          .then(() => this.$toast.open("Success"))
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      });
    },
    setMinDeliveryFee() {
      this.$swal({
        title: `<div style='color:orange'><i class='fa fa-money-bill-alt'></i>&nbsp;<i class='fa fa-shipping-fast'></i></div>`,
        html: `Set a minimum delivery fee.`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Delete",
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("primary"),
        input: "number",
        inputValue: this.workflow.data.min_delivery_fee,
        inputPlaceholder: "15",
        inputValidator: (val) => {
          if (!val) return `Enter a minimum delivery fee or delete`;
        },
      }).then((val) => {
        if (val.dismiss === "backdrop" || val.dismiss === "close") return; // don't do anything

        var fee = parseFloat(val.value);
        if (val.dismiss === "cancel") fee = null; // cancel deletes

        this.workflow.data.min_delivery_fee = fee;

        var loader = this.loadingDots("orange");
        this.$store
          .dispatch("updateWorkflow", {
            id: this.workflow.id,
            data: this.workflow.data,
          })
          .then(() => {
            this.$toast.open("Success");
            this.z += 1;
          })
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      });
    },
    setMaxDistance() {
      this.$swal({
        title: `<div style='color:orange'><i class='fa fa-route'></i>&nbsp;<i class='fa fa-shipping-fast'></i></div>`,
        html: `Set max delivery distance<br><br>Customers will not be able to order a delivery beyond this distance.`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Delete",
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("primary"),
        input: "number",
        inputValue: this.workflow.data.max_distance,
        inputPlaceholder: "10 km",
        inputValidator: (val) => {
          if (!val) return `Enter a maximum distance in km or delete`;
          if (val > 70) return `Enter distance in kilometers not meters`;
        },
      }).then((val) => {
        if (val.dismiss === "backdrop" || val.dismiss === "close") return; // don't do anything

        var max = parseFloat(val.value);
        if (val.dismiss === "cancel") max = null; // cancel deletes

        this.workflow.data.max_distance = max;

        var loader = this.loadingDots("teal");
        this.$store
          .dispatch("updateWorkflow", {
            id: this.workflow.id,
            data: this.workflow.data,
          })
          .then(() => this.$toast.open("Success"))
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      });
    },
    setMinOrder() {
      this.$swal({
        title: `<div style='color:orange'><i class='fa fa-coins'></i>&nbsp;<i class='fa fa-shopping-basket'></i></div>`,
        html: `Set a minimum order value.<br><br>Customers will need to spend at least this much to place an order.`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Delete",
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("primary"),
        input: "number",
        inputValue: this.workflow.data.min_order,
        inputPlaceholder: this.currency + "100",
        inputValidator: (val) => {
          if (!val) return `Enter a minimum order value or delete`;
        },
      }).then((val) => {
        if (val.dismiss === "backdrop" || val.dismiss === "close") return; // don't do anything

        var min = parseFloat(val.value);
        if (val.dismiss === "cancel") min = null; // cancel deletes

        this.workflow.data.min_order = min;

        var loader = this.loadingDots("teal");
        this.$store
          .dispatch("updateWorkflow", {
            id: this.workflow.id,
            data: this.workflow.data,
          })
          .then(() => this.$toast.open("Success"))
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      });
    },
    setRadius() {
      var green = this.bulmaColor("success");
      this.$swal({
        title: `<div style='color:${green}'><i class='far fa-dot-circle'></i></div>`,
        html: `Provide free delivery in a radius around your shop.<br><br><i>Enter radius in meters.</i>`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Set Radius",
        cancelButtonText: "Cancel",
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: green,
        input: "number",
        inputValue: this.workflow.data.free_delivery_to,
        inputPlaceholder: "5000 meters",
        inputValidator: (val) => {
          if (!val) return `Enter a radius or cancel`;
          if (parseInt(val) < 100) return `Enter radius in meters, > 100m`;
        },
      }).then((val) => {
        if (val.value) {
          this.saveCirclePolygon(parseInt(val.value));
        }
      });
    },
    saveCirclePolygon(radiusMeters) {
      const circleToPolygon = require("circle-to-polygon");
      const coordinates = [this.business.lon, this.business.lat]; //[lon, lat]
      const radius = radiusMeters;
      const numberOfEdges = 32; //optional that defaults to 32
      var polygon = circleToPolygon(coordinates, radius, numberOfEdges);
      // console.log("polygon", polygon);
      this.workflow.data.free_delivery_polygon = polygon.coordinates;
      var loader = this.loadingDots("teal");
      this.$store
        .dispatch("updateWorkflow", {
          id: this.workflow.id,
          data: this.workflow.data,
        })
        .then(() => this.$toast.open("Success"))
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    clearPolygon() {
      this.workflow.data.free_delivery_polygon = null;
      var loader = this.loadingDots("teal");
      this.$store
        .dispatch("updateWorkflow", {
          id: this.workflow.id,
          data: this.workflow.data,
        })
        .then(() => this.$toast.open("Success"))
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    setCustom() {
      var green = this.bulmaColor("primary");
      this.$swal({
        title: `<div style='color:${green}'><i class='fa fa-map'></i></div>`,
        html: `Set a custom area or neighbourhood for free delivery.<br><br><i>Please contact the TUK team to set this up.</i>`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: green,
        cancelButtonColor: this.bulmaColor("warning"),
        confirmButtonText: "Contact TUK",
        cancelButtonText: "Later",
      }).then((val) => {
        if (val.value) return window.open("https://m.me/tukapp", "_blank");
      });
    },
    setFreeDeliveryTo() {
      this.$swal({
        title: `<div style='color:teal'><i class='fa fa-map'></i></div>`,
        html: `Provide free delivery to a certain neighbourhood.<br><br><i>Please contact the TUK team to set this up.</i>`,
        showConfirmButton: true,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Delete",
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("primary"),
        input: "text",
        inputValue: this.workflow.data.free_delivery_to,
        inputPlaceholder: "Old Town",
        inputValidator: (val) => {
          if (!val) return `Enter an area name or delete`;
        },
      }).then((val) => {
        if (val.dismiss === "backdrop" || val.dismiss === "close") return; // don't do anything

        var name = val.value;
        if (val.dismiss === "cancel") name = null; // cancel deletes

        this.workflow.data.free_delivery_to = name;
        if (!name && !this.workflow.data.free_delivery_over) {
          this.workflow.data.free_delivery = false;
        } else {
          this.workflow.data.free_delivery = true;
        }

        var loader = this.loadingDots("teal");
        this.$store
          .dispatch("updateWorkflow", {
            id: this.workflow.id,
            data: this.workflow.data,
          })
          .then(() => this.$toast.open("Success"))
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      });
    },
    setFreeDeliveryOver(amount) {
      if (!amount) {
        this.workflow.data.free_delivery_over = false;
        if (!this.workflow.data.free_delivery_to) {
          this.workflow.data.free_delivery = false;
        }
      } else {
        this.workflow.data.free_delivery_over = amount;
        this.workflow.data.free_delivery = true;
      }

      var loader = this.loadingDots("lightgreen");
      this.$store
        .dispatch("updateWorkflow", {
          id: this.workflow.id,
          data: this.workflow.data,
        })
        .then(() => {
          this.$toast.open("Success");
          this.showFreeDeliveryOver = false;
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    freeDeliveryOverInfo() {
      this.$swal({
        title: `<div style='color:orange'><i class='fa fa-shipping-fast'></i></div>`,
        html: `Provide free delivery over a certain order value.<br><br><i>Please contact the TUK team with any questions.</i>`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    freeDeliveryToInfo() {
      this.$swal({
        title: `<div style='color:gold'><i class='fa fa-map'></i></div>`,
        html: `Provide free delivery to a certain neighbourhood.<br><br><i>Please contact the TUK team to set this up.</i>`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    menuDiscountInfo() {
      this.$swal({
        title: `<div style='color:red'><i class='fa fa-tags'></i></div>`,
        html: `Choose a discount rate to apply to your digital menu.<br><br>Discounts will last until you turn them off.<br><br><i>This will override any individual item discounts.</i>`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    dailyPromoInfo() {
      this.$swal({
        title: `<div style='color:blue'><i class='fab fa-facebook'></i></div>`,
        html: `Paste link to daily promo, such as a facebook post.<br><br>Promos will last for 24 hours or until you turn them off.`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    facebookLiveInfo() {
      this.$swal({
        title: `<div style='color:lightgreen'><i class='fa fa-video'></i></div>`,
        html: `Paste link to your live video such as facebook live.<br><br>Your shop will be promoted for up to 12 hours every time you go live.`,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    showUpdatedAt() {
      if (!this.menu) return;
      var dt = new Date(this.menu.updated_at).toLocaleString("en-GB");
      var msg = `Menu last updated<br>${dt}`;
      this.$swal({
        title: "<i class='fa fa-clock'></i>",
        html: msg,
        showConfirmButton: false,
        showCloseButton: true,
      });
    },
    setContentLang(lang, isInit) {
      if (!isInit) this.saveContent();
      this.contentLang = lang;
      this.setContent();
    },
    setContent() {
      this.items.forEach((o) => {
        if (o[this.contentLang]) {
          o.name = o[this.contentLang].name;
          o.description = o[this.contentLang].description;
        }
      });
      this.languageBool = false;
      if (this.items.length > 0) {
        if (!this.items[0].languages) return;
        this.languageBool = this.items[0].languages[this.contentLang];
      }
    },
    saveContent() {
      // don't need to do anything if no items, length 0
      this.items.forEach((o) => {
        o[this.contentLang] = {
          name: o.name,
          description: o.description,
        };
        // check if id exists, if not add one
        if (!o.id) o.id = shortid.generate(); // should change id if name/price changes
        // also save language on/off state, on first item only
        if (!o.languages) o.languages = {};
        o.languages[this.contentLang] = this.languageBool;
      });
    },
    preDiscount(discount) {
      var conflict = false;
      this.items.forEach((o) => {
        if (o.discount) {
          if (o.discount !== discount) conflict = true;
        }
      });
      if (!conflict) return this.applyDiscount(discount);
      var red = this.bulmaColor("danger");
      this.$swal({
        type: "info",
        title: `<div style='color:${red}'>Discount ${discount}&nbsp;<i class="fa fa-percent"></i></div>`,
        html: `This discount rate will override existing discounts on all menu items.`,
        showCancelButton: true,
        confirmButtonText: `Apply ${discount}% discount`,
        cancelButtonText: "Keep old discount",
        confirmButtonColor: this.bulmaColor("primary"),
        cancelButtonColor: this.bulmaColor("info"),
      }).then((val) => {
        if (val.value) this.applyDiscount(discount);
      });
    },
    applyDiscount(discount) {
      this.items.forEach((o) => {
        o.discount = discount;
      });
      this.saveMenu();
    },
    hasPicClass(o) {
      if (o.pic) return "has-text-success";
      return "has-text-danger";
    },
    addItemToMenu() {
      if (this.invalidItems()) return;
      var id = shortid.generate();
      var o = { id: id, name: null, description: null, price: null, pic: null };
      this.items.push(o);
      // scroll to bottom of menu to see new item
      var opts = { top: 99999, behavior: "smooth" };
      if (this.showMenu) {
        this.$nextTick(() => this.$refs.scrollable.scrollTo(opts));
      }
    },
    deleteMenuItem(idx) {
      var item = this.items[idx];
      if (!item.name && !item.price && !item.description) {
        this.items.splice(idx, 1); // if item is empty
        return; // delete without double confirmation
      }
      this.$swal({
        title: "Delete Item?",
        text: "Are you sure you want to delete this item?",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonColor: this.bulmaColor("danger"),
        confirmButtonText: "Yes, Delete It",
      }).then((val) => {
        if (val.value) this.items.splice(idx, 1);
      });
    },
    viewMenu() {
      this.$router.push(`/shop/${this.role.business_id}?tab=promos`);
    },
    viewPolygon() {
      this.$router.push(`/shop/${this.role.business_id}?tab=info`);
    },
    editMenu() {
      if (this.showMenu) this.saveMenu();
      else this.showMenu = true;
    },
    editDescription(o) {
      this.$swal({
        input: "textarea",
        title: o.name,
        imageUrl: o.pic || this.$store.state.errorProfilePic,
        imageHeight: "200px",
        inputValue: o.description || "",
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonText: this.$t("Save Description"),
      }).then((val) => {
        if (val.value) {
          console.log("description", val.value);
          o.description = val.value;
        }
      });
    },
    editStaffNotes(o) {
      this.$swal({
        input: "textarea",
        title: o.name,
        imageUrl: o.pic || this.$store.state.errorProfilePic,
        imageHeight: "200px",
        inputValue: o.notes || "",
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonText: this.$t("Save Staff Notes"),
        confirmButtonColor: "orange",
      }).then((val) => {
        if (val.value) {
          o.notes = val.value;
          this.showStaffNotes = false;
          this.showStaffNotes = true;
        }
      });
    },
    invalidItems() {
      // remove last item if it's blank
      if (this.items.length === 0) return false; // empty list
      var last = this.items[this.items.length - 1];
      if (!last.name && !last.price && !last.description) {
        this.items.pop();
        this.infoToast("Removed blank item", "top");
      }
      var missing = this.items.find((o) => !o.name || !o.price);
      if (missing) {
        var msg = `Invalid menu items. Please set name and price or delete item.`;
        this.warningAlert(msg);
        return true;
      }
      return false;
    },
    saveMenu() {
      this.saveContent();
      if (this.invalidItems()) return;
      // set data
      if (this.menu) {
        this.menu.data = this.items;
      } else {
        this.menu = {
          parent_type: "workflow",
          parent_id: this.role.workflow_id,
          blob_type: "digital_menu",
          data: this.items,
          // data: {
          //   items: this.items,
          //   languages: this.languages
          // }
        };
      }
      // dispatch
      var loader = this.loadingDots("purple");
      this.$store
        .dispatch("saveBlob", this.menu)
        .then((res) => {
          this.menu = res.data;
          this.successToast("Menu Saved!");
          // this.showMenu = false; // hide after save
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    initBlobs(blobs) {
      // this.live = res.data.live;
      // this.promo = res.data.promo;
      this.menu = blobs.find((b) => b.blob_type === "digital_menu");
      if (this.menu) this.items = this.menu.data;
      if (this.items.length === 0) this.addItemToMenu();
      this.setContentLang("en", true);
      if (this.items[0].languages) {
        this.languageBool = this.items[0].languages[this.contentLang];
      }
    },
    getBlobs() {
      if (!this.role) {
        this.warningAlert("Invalid Role");
        return;
      }
      this.updating = true;
      setTimeout(() => (this.updating = false), 1500);
      // get all blobs for this workflow
      this.$store
        .dispatch("getBlobsForWorkflow", this.role.workflow_id)
        .then((res) => {
          console.log("getBlobsForWorkflow", res);
          if (res.data) this.initBlobs(res.data); // if there are blobs, initialise them
        })
        .catch((err) => this.apiError(err));
    },
    takePhoto(idx) {
      this.picIndex = idx;
      if (!this.items[idx].pic) return this.$refs.file.click();
      this.$swal({
        title: this.items[idx].name,
        imageUrl: this.items[idx].pic,
        imageHeight: "200px",
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonText: this.$t("Upload New Picture"),
        confirmButtonColor: "purple",
      }).then((val) => {
        if (val.value) this.$refs.file.click();
      });
    },
    uploadMenuPic(e) {
      console.log("uploadMenuPic", e, e.target);
      if (!e.target.files) return;
      if (e.target.files.length === 0) return;
      var originalFile = e.target.files[0];

      var loader = this.loadingDots();
      var options = {
        maxSizeMB: 0.3,
        maxWidthOrHeight: 400,
        useWebWorker: true,
      };
      imageCompression(originalFile, options)
        .then((compressedFile) => {
          var sizeKB = Math.round(compressedFile.size / 1024);
          this.console(`compressedFile size ${sizeKB} KB`); // smaller than maxSizeMB
          this.zFile += 1;

          imageCompression
            .getDataUrlFromFile(compressedFile)
            .then((base64) => {
              var data = {
                name: shortid.generate() + ".png",
                content: base64.replace(/^data:image\/[a-z]+;base64,/, ""),
                businessID: this.role.business_id,
                imageType: "digital_menu",
              };
              this.$store
                .dispatch("uploadImageAWS", data)
                .then((res) => {
                  console.log("uploadImageAWS", res.data);
                  // var url = JSON.parse(res.data.body).Location;
                  var url = res.data.compressed_image_url;
                  this.items[this.picIndex].pic = url;
                  this.successToast("Success!");
                  // this.save();
                  // this.toggle = true; // open pic toggle
                })
                .catch((err) => this.apiError(err))
                .finally(() => loader.hide());
            })
            .catch((err) => this.console("imageData error", err));
        })
        .catch((err) => this.console("imageCompression error", err));
    },
  },
};
</script>

<style scoped>
div.card-content {
  padding: 6px;
  overflow: hidden !important;
}
.tag {
  padding: 0 6px;
}
.label {
  margin-top: 12px;
}
.modal-close {
  top: 10px;
  right: 12px;
}
.full-width {
  width: 100vw !important;
}
.modal-card {
  width: 95vw;
}
.modal-card-body {
  padding: 12px;
  border-radius: 25px;
  max-height: 85vh;
}
.discounts span {
  margin-right: 8px;
}
.button.is-small.is-rounded {
  padding: 0 4px;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.is-marginless .tag {
  margin: 0 0;
}
.notes p {
  margin-top: -4px;
  border: 1px solid rgb(240, 240, 240);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 4px;
  white-space: pre-wrap;
}
.input.is-light {
  background-color: rgb(250, 250, 250);
}
.updating {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 10px;
}
.advanced-btn {
  height: 30px;
  font-size: 0.85em;
  padding: 12px;
}
</style>

<style>
.swal2-textarea {
  margin: 0;
}
.swal2-close {
  color: grey;
}
</style>